import {
    ProcessedRunResultResponse,
    ProcessedRunResultRow,
} from '../../../store/RunResults';
import { wrapDateStringInMoment } from './dateUtils';

const MAX_NUMBER_OF_RESULT_PAGES = 5;

export type WeeklyResultsData = {
    pages: Array<ProcessedRunResultRow[]>;
    pageLabels: string[];
};

const getWeeklyResults = (
    response: ProcessedRunResultResponse
): WeeklyResultsData => {
    let recordsPages: Array<ProcessedRunResultRow[]> = [];
    let recordPageLabels: string[] = [];

    if (!response || !response.rows.length) {
        return {
            pages: recordsPages,
            pageLabels: recordPageLabels,
        };
    }

    let currentPage: ProcessedRunResultRow[] = [];
    let limitDate = null;

    for (let i = 0; i < response.rows.length; i++) {
        let currentRow: ProcessedRunResultRow = response.rows[i];
        if (!limitDate) {
            limitDate = wrapDateStringInMoment(currentRow.date).startOf(
                'isoWeek'
            );
        }
        let isBefore: boolean = wrapDateStringInMoment(
            currentRow.date
        ).isBefore(limitDate);

        if (isBefore) {
            limitDate = wrapDateStringInMoment(currentRow.date).startOf(
                'isoWeek'
            );

            recordsPages.unshift(currentPage);
            let currentPageLabel = wrapDateStringInMoment(
                currentPage[0].date
            ).isoWeek();
            recordPageLabels.unshift(currentPageLabel);

            currentPage = [];
            currentPage.push(currentRow);
        } else {
            currentPage.push(currentRow);
        }
    }

    if (currentPage.length) {
        recordsPages.unshift(currentPage);
        let currentPageLabel = wrapDateStringInMoment(
            currentPage[0].date
        ).isoWeek();
        recordPageLabels.unshift(currentPageLabel);
    }

    return {
        pages: recordsPages.slice(-MAX_NUMBER_OF_RESULT_PAGES),
        pageLabels: recordPageLabels.slice(-MAX_NUMBER_OF_RESULT_PAGES),
    };
};

export default getWeeklyResults;
